import { FC } from "react";
import { Card, createStyles, makeStyles } from "@material-ui/core";

import { formatMoney } from "lib/helpers";
import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    tooltipContainer: {
      padding: theme.spacing(2),
      border: `1px solid ${theme.custom.palette.gray.dark}`,
    },
  }),
);
import { titleize } from "underscore.string";

interface PayloadItem {
  dataKey: string;
  value: number;
  payload: {
    x: number;
    y: number;
  };
}

interface CustomTooltipProps {
  active?: boolean;
  payload?: PayloadItem[];
  label?: string;
  displayTotal?: boolean;
}

export const CustomTooltip: FC<CustomTooltipProps> = ({
  active,
  payload,
  label,
  displayTotal = true,
}) => {
  const classes = useStyles();

  if (active) {
    const total: number = payload[0].payload.y;
    return (
      <Card className={classes.tooltipContainer}>
        {label && <p>{label}</p>}
        {displayTotal && <p>{`Total: $${formatMoney(total, 0)}`}</p>}
        {payload.map(item => (
          <p key={`item-${item.dataKey}`}>{`${titleize(
            item.dataKey,
          )}: $${formatMoney(item.value, 0)}`}</p>
        ))}
      </Card>
    );
  }
  return null;
};
